export const FIT_TO_DATA_ZOOM = 12;

export const FIT_TO_DATA_PADDING = 100;

export {
    GEOJSON_FEATURE_TYPE,
    GEOJSON_FEATURE_COLLECTION
} from 'components/Map/hooks/useFeatures/constants';
